(function(){
var still=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function go(v){if(v.getAttribute('src'))return;v.src=v.getAttribute('data-src');v.load();
var p=v.play();if(p&&p.catch)p.catch(function(){});}
if(still){
[].slice.call(document.querySelectorAll('video[autoplay]')).forEach(function(v){v.removeAttribute('autoplay');v.pause();v.load();});
[].slice.call(document.querySelectorAll('[data-snd]')).forEach(function(b){b.addEventListener('click',function(){
var s=b.closest('section'),v=s&&s.querySelector('video[data-src]');if(v)go(v);});});
return;}
var vids=[].slice.call(document.querySelectorAll('video[data-src]'));
if(!vids.length)return;
function loop(v){return !!(v.classList&&v.classList.contains('broll-v'));}
function near(loops){
if(!loops.length)return;
if(!('IntersectionObserver' in window)){loops.forEach(go);return;}
var io=new window.IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){io.unobserve(e.target);go(e.target);}});},{rootMargin:'300px 0px'});
loops.forEach(function(v){io.observe(v);});}
function start(){vids.forEach(function(v){if(!loop(v))go(v);});near(vids.filter(loop));}
if(document.readyState==='complete')start();else window.addEventListener('load',start);})();
